<template>
  <div>
    <a
      href="#"
      @click.prevent="showModal"
      data-feedback-trigger="true"
      class="group flex items-center gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-100 hover:text-gray-900"
    >
      <component :is="iconsMap[icon]" class="h-6 w-6 shrink-0 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
      <span>{{ props.text }}</span>
    </a>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import Feedback from '@betahuhn/feedback-js'
import { useGettext } from "vue3-gettext";
import { useAuth0 } from "@auth0/auth0-vue";

import {
  LifebuoyIcon,
} from "@heroicons/vue/24/outline";

const { $gettext } = useGettext()

const feedback = ref(null)

const props = defineProps({
  text: {
    type: String
  },
  icon: {
    type: String
  },
  email: {
    type: String
  }
})

const iconsMap = {
  LifebuoyIcon: LifebuoyIcon
}

const email = props.email

onMounted(async () => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  let token;
  try {
    token = await getAccessTokenSilently();
  } catch (e) {
    console.warn("Silent auth failed:", e);
    await loginWithRedirect();
    return; // Page will redirect; component will remount after login
  }

  feedback.value = new Feedback({
    endpoint: `${import.meta.env.VITE_API_SERVER_URL}/api/feedbacks`,
    method: 'POST',
    title: $gettext('Aide & Feedback'),
    forceShowButton: false,
    typeMessage: $gettext('Comment pouvons nous vous aider?'),
    success: $gettext('✅ Merci!'),
    inputPlaceholder: $gettext('Entrez votre message ici...'),
    submitText: $gettext('Envoyer'),
    backText: $gettext('Retour'),
    failedTitle: $gettext('Désolé, une erreur s\'est produite'),
    failedMessage: $gettext('Réessayez. Si le problème persiste, contactez nous par email.'),
    position: 'right',
    primary: 'oklch(51.1% 0.262 276.966)',
    background: '#fff',
    color: '#000',
    types: {
      general: {
        text: $gettext('J\'ai du feedback pour vous'),
        icon: '💬'
      },
      idea: {
        text: $gettext('J\'ai une idée d\'amélioration'),
        icon: '💡'
      },
      bug: {
        text: $gettext('J\'ai trouvé un bug'),
        icon: '🐞'
      }
    }
  })

  feedback.value.sendToEndpoint = function (data) {
    this.renderLoading()
    data.email = email
    const request = new XMLHttpRequest()
    request.open('POST', this.options.endpoint)
    request.setRequestHeader('Content-type', 'application/json')
    request.setRequestHeader('Authorization', `Bearer ${token}`)
    request.send(JSON.stringify(data))
    request.onreadystatechange = () => {
      if (request.readyState === 4) {
        if (request.status === 200) {
          return this.renderSuccess()
        }
        this.renderFailed()
      }
    }
  }

  feedback.value.renderSuccess = function () {
    if (!this.root) return

    const html = `
			<div class="feedback-btn-wrapper">
				<button id="feedback-btn" title="Success">
					<span>${ this.options.success }</span>
				</button>
			</div>
    `
    this.root.innerHTML = html

    setTimeout(() => {
      const wrapper = document.getElementById('feedback-btn')
      if (wrapper) {
        wrapper.remove()
      }
    }, 3000)
  }
})

const showModal = () => {
  feedback.value.renderModal()
}
</script>
